import {debounce} from "../_functions";

document.addEventListener('DOMContentLoaded', (dom) => {
    const container = dom.target;
    const shopsList = container.querySelectorAll('.list__shop');
    const searchInput = container.querySelector('.js-shops-page-search-input');

    if (shopsList.length && searchInput) {

        const getTitle = (el) => {
            const title = el.querySelector('.shop__title');
            return title ? title.innerText.toLowerCase() : '';
        };

        const getShopLocation = (el) => {
            const shopLocation = el.querySelector('.shop__location');
            return shopLocation ? shopLocation.textContent.toLowerCase() : '';
        };

        const filterShops = () => {
            const searchTerm = searchInput.value.trim().toLowerCase();

            let shopsArray = Array.from(shopsList);

            shopsArray.forEach(post => {
                const titleText = getTitle(post);
                const shopLocationText = getShopLocation(post);
                const matchSearch = searchTerm === '' || titleText.includes(searchTerm) || shopLocationText.includes(searchTerm);

                post.classList.toggle('hidden', !(matchSearch));
            });

            const shopsWrapper = shopsList[0].parentNode;

            const fragment = document.createDocumentFragment();
            shopsArray.forEach(el => fragment.appendChild(el));
            shopsWrapper.appendChild(fragment);
        };

        const handleInput = debounce(filterShops, 300);

        searchInput.addEventListener('input', handleInput);

        filterShops();
    }
});
